import { AnyAction } from 'redux';
import {
  AIRPORTS_GET,
  AIRPORT_SELECT,
  AIRPORT_FILTER_CLEAR,
} from './airports.actions';
import { Airport } from '../model/types';

type AirportsState = {
  list: (Airport & { selected: boolean })[];
};

const initialState: AirportsState = {
  list: [],
};
// TODO prevent re-rendering when editing airports functionality will be added

const airports = (
  state: AirportsState = initialState,
  action: AnyAction
): AirportsState => {
  switch (action.type) {
    case AIRPORTS_GET: {
      return {
        ...state,
        list: action.payload.airports.map(ap => ({ ...ap, selected: false })),
      };
    }
    case AIRPORT_SELECT:
      return {
        ...state,
        list: state.list.map(item =>
          item.name === action.payload.name
            ? { ...item, selected: action.payload.selected }
            : item
        ),
      };
    case AIRPORT_FILTER_CLEAR:
      return {
        ...state,
        list: state.list.map(ap => ({ ...ap, selected: false })),
      };
    default:
      return state;
  }
};

export default airports;
